import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/security/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DomainService } from './domain-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../security/auth.service";
import * as i3 from "ngx-toastr";
import * as i4 from "./domain-service";
var LegalibooService = /** @class */ (function () {
    function LegalibooService(http, authService, toastr, domainService) {
        this.http = http;
        this.authService = authService;
        this.toastr = toastr;
        this.domainService = domainService;
    }
    LegalibooService.prototype.getLegalibooConfig = function () {
        var url = this.domainService.backendUrlWithContext + '/legaliboo/auth/';
        return this.http.get(url).toPromise();
    };
    LegalibooService.prototype.legalibooAccess = function () {
        var url = this.domainService.backendUrlWithContext + '/legaliboo/access/';
        var form = new FormData();
        form.append('documentNumber', this.authService.getUser().documentNumber.toString());
        return this.http.post(url, form).toPromise();
    };
    LegalibooService.ngInjectableDef = i0.defineInjectable({ factory: function LegalibooService_Factory() { return new LegalibooService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService), i0.inject(i3.ToastrService), i0.inject(i4.DomainService)); }, token: LegalibooService, providedIn: "root" });
    return LegalibooService;
}());
export { LegalibooService };
